"use client";

import { Box, Flex, Skeleton } from "@chakra-ui/react";
import { MAP_EMBED_CONFIG } from "@/lib/config/mapEmbed";
import { useThemeTokens } from "@/lib/theme/tokens";

export const LocationPublicPageSkeleton = () => {
  const theme = useThemeTokens();

  return (
    <Flex direction="column" maxW="720px" mx="auto" w="100%">
      <Skeleton height="20px" width="200px" mb={6} borderRadius="4px" />

      <Skeleton
        w="100%"
        height={{ base: "200px", md: "280px" }}
        borderRadius="12px"
        mb={6}
      />

      <Box pb={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Skeleton height="12px" width="88px" mb={3} borderRadius="4px" />
        <Skeleton height={{ base: "34px", md: "42px" }} width="70%" mb={3} borderRadius="6px" />
        <Skeleton height="16px" width="90%" mb={2} borderRadius="4px" />
        <Skeleton height="16px" width="55%" mb={4} borderRadius="4px" />
        <Flex gap={3}>
          <Skeleton height="36px" width="120px" borderRadius="8px" />
          <Skeleton height="36px" width="88px" borderRadius="8px" />
        </Flex>
      </Box>

      <Box py={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Flex direction="column" gap={2}>
          <Skeleton height="16px" width="100%" borderRadius="4px" />
          <Skeleton height="16px" width="92%" borderRadius="4px" />
          <Skeleton height="16px" width="78%" borderRadius="4px" />
        </Flex>
      </Box>

      <Box py={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Skeleton height="12px" width="56px" mb={4} borderRadius="4px" />
        <Skeleton
          height={MAP_EMBED_CONFIG.height}
          width="100%"
          borderRadius={MAP_EMBED_CONFIG.innerRadius}
        />
      </Box>

      <Box py={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Skeleton height="12px" width="100px" mb={4} borderRadius="4px" />
        <Flex gap={8} py={4} borderTopWidth="1px" borderColor={theme.borderGlass.subtle}>
          <Skeleton height="12px" width="72px" borderRadius="4px" />
          <Skeleton height="20px" width="50%" borderRadius="4px" flex={1} />
          <Skeleton height="32px" width="120px" borderRadius="8px" />
        </Flex>
      </Box>

      <Box pt={3}>
        <Skeleton height="12px" width="110px" mb={4} borderRadius="4px" />
        <Box borderTopWidth="1px" borderColor={theme.borderGlass.subtle}>
          {[1, 2].map((i) => (
            <Flex
              key={i}
              justify="space-between"
              align="center"
              py={4}
              borderBottomWidth="1px"
              borderColor={theme.borderGlass.subtle}
            >
              <Box flex={1}>
                <Skeleton height="12px" width="72px" mb={2} borderRadius="4px" />
                <Skeleton height="16px" width="140px" borderRadius="4px" />
              </Box>
              <Skeleton boxSize="16px" borderRadius="4px" />
            </Flex>
          ))}
        </Box>
      </Box>
    </Flex>
  );
};
